import React from 'react';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';

import MainLayout from '@views/layouts/main-layout';
import Breadcrumb from '@views/modules/search/sub-modules/breadcrumb';
import SearchBlock from '@views/modules/search/dynamic';
import { HOST } from '@lib/helpers';

export const Search: NextPage = (): JSX.Element => {
  return (
    <MainLayout breadcrumb={<Breadcrumb />}>
      <NextSeo title="Tìm kiếm" canonical={`${HOST}/tim-kiem`} />
      <SearchBlock />
    </MainLayout>
  );
};

export default Search;
